import { render, staticRenderFns } from "./applyDelivery.vue?vue&type=template&id=619ae476&scoped=true&"
import script from "./applyDelivery.vue?vue&type=script&lang=js&"
export * from "./applyDelivery.vue?vue&type=script&lang=js&"
import style0 from "./applyDelivery.vue?vue&type=style&index=0&id=619ae476&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619ae476",
  null
  
)

export default component.exports